import { memo } from 'react';
import ContTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ContTitle';
import ToggleNotice from '@wconcept/wconcept-ui-renewal/components/molecules/_notice/ToggleNotice';
import CouponItem2Skeleton from '@wconcept/wconcept-ui-renewal/components/molecules/_skeleton/CouponItem2Skeleton';
import BasicBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/BasicBtn';
import { IconDownload01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface CustomColorType {
  bgColor?: string;
  textColor?: string;
}

type ColorType = 'white' | 'black' | CustomColorType | string;

function resolveNoticeBarColorType(
  colorType: ColorType
): 'gray' | 'black' | 'opacity' {
  if (colorType === 'white') {
    return 'gray';
  }
  if (colorType === 'black') {
    return 'black';
  }
  return 'opacity';
}

function resolveSkeletonCouponBgType(
  isCustomColor: boolean,
  colorType: ColorType
): 'opacity' | 'black' | 'white' {
  if (isCustomColor) {
    return 'opacity';
  }
  if (colorType === 'black') {
    return 'black';
  }
  return 'white';
}

interface IProps {
  colorType?: ColorType;
  title?: string;
  subTitle?: string;
  isDesktop?: boolean;
  isLoaded?: boolean;
  couponList?: React.ReactNode;
  noticeList?: string[];
  onNoticeToggle?: (active: boolean) => void;
  onClick?: () => void;
}

const CouponSection3 = ({
  colorType = 'white',
  title,
  subTitle,
  isDesktop,
  isLoaded,
  couponList,
  noticeList,
  onNoticeToggle,
  onClick,
}: IProps) => {
  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;
  const couponSkeletonKeyList = isDesktop
    ? ['fcfs-coupon-skel-1', 'fcfs-coupon-skel-2', 'fcfs-coupon-skel-3']
    : ['fcfs-coupon-skel-1', 'fcfs-coupon-skel-2'];

  const cName = classNameBind([
    'coupon-list',
    !isCustomColor ? `bg-type-${colorType}` : '',
  ]);

  return (
    <S.CouponSection3
      className={cName}
      $bgColor={customColors?.bgColor}
      $textColor={customColors?.textColor}
    >
      <ContTitle
        title={title}
        subTitle={subTitle}
        titleColor={customColors?.textColor}
        subTitleColor={customColors?.textColor}
      />

      <div className="coupon-wrap">
        {!isLoaded
          ? couponSkeletonKeyList.map(skeletonKey => (
              <CouponItem2Skeleton
                key={skeletonKey}
                bgType={resolveSkeletonCouponBgType(isCustomColor, colorType)}
                bgColor={customColors?.bgColor}
              />
            ))
          : couponList}
      </div>

      <BasicBtn
        text="모든 쿠폰 받기"
        type="line"
        size="large"
        afterIcon={<IconDownload01 />}
        onClick={onClick}
      />

      {noticeList && (
        <ToggleNotice
          noticeList={noticeList}
          onNoticeToggle={onNoticeToggle}
          titleColor={customColors?.textColor}
          noticeColor={customColors?.textColor}
          hideBullet
        />
      )}
    </S.CouponSection3>
  );
};

export default memo(CouponSection3);
